import { createBrowserRouter, type RouterProviderProps } from 'react-router-dom';
import { AdminLayout } from '@/components/AdminLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { AdminMaintenancePage } from '@/pages/AdminMaintenancePage';
import { AdminStoragePage } from '@/pages/AdminStoragePage';
import { AdminSessionsPage } from '@/pages/AdminSessionsPage';
import { AdminNotificationsPage } from '@/pages/AdminNotificationsPage';
import { AdminSmtpPage } from '@/pages/AdminSmtpPage';
import { BackupPage } from '@/pages/BackupPage';
import { AdminTreesPage } from '@/pages/AdminTreesPage';
import { AdminUsersPage } from '@/pages/AdminUsersPage';
import { AdminRolesPage } from '@/pages/AdminRolesPage';
import { AdminAuditLogPage } from '@/pages/AdminAuditLogPage';
import { EinstellungenPage } from '@/pages/EinstellungenPage';
import { SystemPage } from '@/pages/SystemPage';
import { TarifePage } from '@/pages/TarifePage';
import { ShopPage } from '@/pages/ShopPage';
import { SicherheitPage } from '@/pages/SicherheitPage';
import { SperrenPage } from '@/pages/SperrenPage';
import { TextePage } from '@/pages/TextePage';
import { ZugangPage } from '@/pages/ZugangPage';
import { RundnachrichtenPage } from '@/pages/RundnachrichtenPage';
import { VersandprotokollPage } from '@/pages/VersandprotokollPage';
import { MitwirkungPage } from '@/pages/MitwirkungPage';
import { VorschlaegePage } from '@/pages/VorschlaegePage';
import { ForumPage } from '@/pages/ForumPage';

// Deutsche Pfade, weil sie sichtbar sind – die Seiten selbst behalten ihre
// englischen Dateinamen aus der Anwendung, damit ein Vergleich mit dem
// Original einfach bleibt.
//
// Typ explizit: sonst versucht tsc den internen Router-Typ aus @remix-run/router
// zu benennen (TS2742). Gleiche Lösung wie in der Anwendung.
export const router: RouterProviderProps['router'] = createBrowserRouter([
  {
    element: <AdminLayout />,
    children: [
      { path: '/', element: <DashboardPage /> },
      { path: '/system', element: <SystemPage /> },
      { path: '/sicherheit', element: <SicherheitPage /> },
      { path: '/einstellungen', element: <EinstellungenPage /> },
      { path: '/tarife', element: <TarifePage /> },
      { path: '/shop', element: <ShopPage /> },
      { path: '/texte', element: <TextePage /> },
      { path: '/zugang', element: <ZugangPage /> },

      // Betrieb
      { path: '/wartung', element: <AdminMaintenancePage /> },
      { path: '/speicher', element: <AdminStoragePage /> },
      { path: '/sitzungen', element: <AdminSessionsPage /> },
      { path: '/benachrichtigungen', element: <AdminNotificationsPage /> },
      { path: '/email', element: <AdminSmtpPage /> },
      { path: '/rundnachrichten', element: <RundnachrichtenPage /> },
      { path: '/versandprotokoll', element: <VersandprotokollPage /> },
      { path: '/mitwirkung', element: <MitwirkungPage /> },
      { path: '/vorschlaege', element: <VorschlaegePage /> },
      { path: '/forum', element: <ForumPage /> },

      // Daten
      { path: '/sicherungen', element: <BackupPage /> },
      { path: '/stammbaeume', element: <AdminTreesPage /> },

      // Zugang
      { path: '/konten', element: <AdminUsersPage /> },
      { path: '/rollen', element: <AdminRolesPage /> },
      { path: '/sperren', element: <SperrenPage /> },
      { path: '/protokoll', element: <AdminAuditLogPage /> },
    ],
  },
]);
